module.exports = __webpack_public_path__ + "static/media/70c07419.jpg";